import { Search } from "@mui/icons-material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Box } from "@mui/material";
import Tab from "@mui/material/Tab";
import { useEffect, useRef, useState } from "react";
import { ToastContainer } from "react-toastify";
import { getOrderStatus } from "../../../../apis/cart/Order/OrderStatusHistory";
import { FullHeightLoader } from "../../../../components/Loader/FullHeightLoader";
import { OrderList } from "../../components/Order/OrderList";

export const List = () => {
	const [value, setValue] = useState("0");
	const [loading, setLoading] = useState(false);
	const didInitialize = useRef(false);
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	const [tabs, setTabs] = useState([]);
	const getStatus = async () => {
		if (!didInitialize.current) {
			setLoading(true);
		}
		const res = await getOrderStatus();
		setTabs(res.results);
		if (res.results.length && !didInitialize.current) {
			setValue(res.results[0].id.toString()); // ✅ Use res.results instead of tabs
		}
		if (!didInitialize.current) {
			setLoading(false);
			didInitialize.current = true;
		}
	};

	useEffect(() => {
		getStatus();
	}, []);

	const handleStatusChange = () => {
		getStatus(); // Refresh tabs after a status update
	};

	return (
		<Box>
			<ToastContainer />
			{loading ? (
				<FullHeightLoader />
			) : (
				<TabContext value={value}>
					<Box sx={{ px: 5, pt: 5 }}>
						<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
							<TabList
								onChange={handleChange}
								aria-label="lab API tabs example"
							>
								{tabs.map(
									({ name, id, order_count }, index) => (
										<Tab
											key={`tab-${index}`}
											label={`${name} (${order_count})`}
											value={id.toString()}
										/>
									)
								)}
								<Tab
									iconPosition="start"
									label={"Search Orders"}
									value={"0"}
									sx={{
										minHeight: 48,
										// fontSize: 13,
										// py: 0.5,
										// px: 1.5,
										// gap: 0.5,
									}}
									icon={
										<Search
											color="primary"
											sx={{
												animation:
													"pulse 1s ease-in-out infinite",
												"@keyframes pulse": {
													"0%": {
														transform: "scale(1)",
													},
													"50%": {
														transform: "scale(1.2)",
													},
													"100%": {
														transform: "scale(1)",
													},
												},
											}}
										/>
									}
								/>
							</TabList>
						</Box>
					</Box>
					<Box>
						<TabPanel value={"0"}>
							<Box sx={{ px: 5 }}>
								<OrderList
									status={""}
									name={""}
									searchOpen={true}
								/>
							</Box>
						</TabPanel>
						{tabs.map(({ name, id }, index) => (
							<TabPanel
								value={id.toString()}
								key={`tab-panel-${index}`}
							>
								<Box sx={{ px: 5 }}>
									<OrderList
										status={id}
										name={name}
										onStatusChange={handleStatusChange}
									/>
								</Box>
							</TabPanel>
						))}
					</Box>
				</TabContext>
			)}
		</Box>
	);
};
